export default __webpack_public_path__ + "assets/7b27349f805fa186326d4a62dbdc5405.svg";